import { render, staticRenderFns } from "./AccClass.vue?vue&type=template&id=9513371e&scoped=true&"
import script from "./AccClass.vue?vue&type=script&lang=js&"
export * from "./AccClass.vue?vue&type=script&lang=js&"
import style0 from "./AccClass.vue?vue&type=style&index=0&id=9513371e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9513371e",
  null
  
)

component.options.__file = "AccClass.vue"
export default component.exports